import { all, fork } from 'redux-saga/effects';
import * as sagas from './saga.index';

export default function* rootSaga() {
  yield all(Object.keys(sagas).map(saga => fork(sagas[saga])));
}
